import { Select, SelectItem } from '@mantine/core';
import { useCallback } from 'react';

interface IViewAppointmentsCountSelectProps {
  numOfAppointmentsDisplayed: string;
  setNumOfAppointmentsDisplayed: React.Dispatch<React.SetStateAction<string>>;
  numOfAppointmentsDisplayedList: SelectItem[];
}

function ViewAppointmentsCountSelect({
  numOfAppointmentsDisplayed,
  setNumOfAppointmentsDisplayed,
  numOfAppointmentsDisplayedList,
}: IViewAppointmentsCountSelectProps) {
  const onAppointmentNumberChange = useCallback(
    (value: string | null) => {
      if (value) setNumOfAppointmentsDisplayed(value);
    },
    [setNumOfAppointmentsDisplayed]
  );

  return (
    <Select
      data={numOfAppointmentsDisplayedList}
      onChange={onAppointmentNumberChange}
      value={numOfAppointmentsDisplayed}
      size="lg"
    />
  );
}

export default ViewAppointmentsCountSelect;
